import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";
import { StarMark } from "@core/icons";

// Adaptación a escritorio de Marca (context/prototype/source/validador.jsx:113-121):
// el prototipo es mobile full-bleed, acá es una tarjeta centrada en el
// viewport (decisión aprobada, ver mensaje de la corrida de SPEC-221).
export function AccessLayout({
  sub,
  title,
  children,
}: {
  sub?: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <main
      aria-label={title ?? sub ?? "Acceso al portal"}
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "radial-gradient(1200px 760px at 16% -10%, #1d1d22 0%, rgba(29,29,34,0) 55%), " +
          "radial-gradient(1000px 640px at 112% 6%, #19191d 0%, rgba(25,25,29,0) 52%), " +
          "linear-gradient(180deg, #0c0c0e 0%, #0a0a0b 100%)",
        padding: 24,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 18,
          background: tokens.surface.surface,
          border: `1px solid ${tokens.surface.line}`,
          boxShadow: tokens.shadow,
          padding: "44px 38px 38px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 34 }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <StarMark size={46} ring stroke={1} />
          </div>
          <div
            style={{
              font: `600 12px ${tokens.font.ui}`,
              letterSpacing: "0.34em",
              textTransform: "uppercase",
              color: tokens.text.secondary,
              marginTop: 14,
            }}
          >
            Star Circle
          </div>
          {sub ? (
            <div
              style={{
                font: `500 13px ${tokens.font.ui}`,
                color: tokens.text.tertiary,
                marginTop: 7,
              }}
            >
              {sub}
            </div>
          ) : null}
        </div>
        {title ? (
          <h1
            style={{
              position: "absolute",
              width: 1,
              height: 1,
              padding: 0,
              margin: -1,
              overflow: "hidden",
              clip: "rect(0, 0, 0, 0)",
              whiteSpace: "nowrap",
              border: 0,
            }}
          >
            {title}
          </h1>
        ) : null}
        {children}
      </div>
    </main>
  );
}
